import { WhoAmIResponse } from "@ns/api";
import { create } from "zustand";

export type Auth = {
  user: WhoAmIResponse | null;
  setUser: (whoAmIResponse: WhoAmIResponse | null) => void;
  isDeletedFiles: boolean;
  setIsDeletedFiles: (isDeletedFiles: boolean) => void;
  resizeToMobile: boolean;
  setResizeToMobile: (resizeToMobile: boolean) => void;
};

const useUserStore = create<Auth>((set) => ({
  user: null,
  isDeletedFiles: false,
  setUser: (whoAmIResponse: WhoAmIResponse | null) =>
    set({ user: whoAmIResponse }),
  setIsDeletedFiles: (isDeletedFiles: boolean) =>
    set({ isDeletedFiles: isDeletedFiles }),
  resizeToMobile: false,
  setResizeToMobile: (resizeToMobile: boolean) =>
    set({ resizeToMobile: resizeToMobile }),
}));

export default useUserStore;
